import React from 'react';
import type { Dispatch } from 'react';

import Select from '@atlaskit/select';

import { fg } from '@confluence/feature-gating';

import type { FilterKeys, SelectOptions } from './filtersDefinitions';
import {
	FilterHeader,
	InputContainer,
	SelectContainer,
	FilterHeaderCompiled,
	InputContainerCompiled,
	SelectContainerCompiled,
} from './presentationalComponents';

interface SelectFilterProps<T> {
	filterKey: FilterKeys; // Used to determine which filter to update in context.
	options: SelectOptions<T>[]; // The options to pass the select.
	label: string;
	inputId: string;
	filterDispatch?: Dispatch<any>;
	value?: SelectOptions<T> | null;
	onChange?: (props) => void;
}

export const SelectFilter = <T extends unknown>({
	options,
	filterKey,
	label,
	inputId,
	filterDispatch,
	onChange,
	value,
}: SelectFilterProps<T>) => {
	const onFilterChange = (props: SelectOptions<T> | null) => {
		if (onChange) {
			onChange(props);
		} else if (filterDispatch) {
			filterDispatch({ type: filterKey, payload: props?.value });
		}
	};

	if (fg('confluence_frontend_home_compiled_migration')) {
		return (
			<InputContainerCompiled>
				<FilterHeaderCompiled htmlFor={inputId}>{label}</FilterHeaderCompiled>
				<SelectContainerCompiled>
					<Select
						id={inputId}
						options={options}
						value={value}
						onChange={onFilterChange}
						isSearchable={false}
						// for test utilities purposes
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className={inputId}
						classNamePrefix="react-select"
					/>
				</SelectContainerCompiled>
			</InputContainerCompiled>
		);
	}

	return (
		<InputContainer>
			<FilterHeader htmlFor={inputId}>{label}</FilterHeader>
			<SelectContainer>
				<Select
					id={inputId}
					options={options}
					value={value}
					onChange={onFilterChange}
					isSearchable={false}
					// for test utilities purposes
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={inputId}
					classNamePrefix="react-select"
				/>
			</SelectContainer>
		</InputContainer>
	);
};
